import React from 'react';
import { fetchSettings } from "../AppData";
import { NavLink, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTranslation } from '../hooks/useTranslation';

function Drawer() {
    const [settings, setSettings] = useState({});
    const { t } = useTranslation();

    useEffect(() => {
        fetchSettings().then((data) => setSettings(data));
    }, []);

    const renderLogo = () => {
        if (settings.site_logo) {
            return (
                <img
                    src={settings.site_logo}
                    alt={settings.site_name || "Logo"}
                    style={{
                        height: "32px",
                        objectFit: "contain",
                        maxWidth: "180px"
                    }}
                />
            );
        }

        return (
            <>
                <div className="logo-icon"></div>
                <span style={{ fontSize: "22px", fontWeight: 400 }}>
                    {settings.site_name || "Your Site"}
                </span>
            </>
        );
    };

    return (
        <>
            <div className="drawer" id="drawer">
                <div className="drawer-header">
                    <button className="drawer-close" id="drawerClose">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                        </svg>
                    </button>
                    <div className="drawer-logo">
                        <span className="drawer-logo-text">{renderLogo()}</span>
                    </div>
                </div>

                <div className="drawer-menu">
                    <div className="drawer-section">

                        <NavLink to="/" className={({ isActive }) => "drawer-item" + (isActive ? " active" : "")}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                                <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z" />
                            </svg>
                            {t('Home')}
                        </NavLink>

                        <NavLink to="/apps" className={({ isActive }) => "drawer-item" + (isActive ? " active" : "")}>
                            <svg className="drawer-item-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M4,6H20V16H4M20,18A2,2 0 0,0 22,16V6C22,4.89 21.1,4 20,4H4A2,2 0 0,0 2,6V16A2,2 0 0,0 4,18H0V20H24V18H20Z" />
                            </svg>
                            {t('Apps')}
                        </NavLink>

                        <NavLink to="/games" className={({ isActive }) => "drawer-item" + (isActive ? " active" : "")}>
                            <svg className="drawer-item-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M21,6V8H3V6H21M3,18V16H21V18H3M3,13H21V11H3V13Z" />
                            </svg>
                            {t('Games')}
                        </NavLink>

                        <NavLink to="/blogs" className={({ isActive }) => "drawer-item" + (isActive ? " active" : "")}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none" />
                                <circle cx="6.18" cy="17.82" r="2.18" />
                                <path d="M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z" />
                            </svg>
                            {t('Blogs')}
                        </NavLink>

                    </div>

                    <div className="drawer-divider"></div>

                    <div className="drawer-section">
                        <div className="drawer-section-title">{t('My Play')}</div>
                        <NavLink to="/my-apps" className={({ isActive }) => "drawer-item" + (isActive ? " active" : "")}>
                            <svg className="drawer-item-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M12,6A6,6 0 0,0 6,12A6,6 0 0,0 12,18A6,6 0 0,0 18,12A6,6 0 0,0 12,6Z" />
                            </svg>
                            {t('My apps & games')}
                        </NavLink>
                        <NavLink to="/wishlist" className={({ isActive }) => "drawer-item" + (isActive ? " active" : "")}>
                            <svg className="drawer-item-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M5,9V21H1V9H5M9,21A2,2 0 0,1 7,19V9C7,8.45 7.22,7.95 7.59,7.59L14.17,1L15.23,2.06C15.5,2.33 15.67,2.7 15.67,3.11L15.64,3.43L14.69,8H21C22.11,8 23,8.9 23,10V12C23,12.26 22.95,12.5 22.86,12.73L19.84,19.78C19.54,20.5 18.83,21 18,21H9M9,19H18.03L21,12V10H12.21L13.34,4.68L9,9.03V19Z" />
                            </svg>
                            {t('Wishlist')}
                        </NavLink>
                        {/* <a href="#" className="drawer-item">
                            <svg className="drawer-item-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M14,12H10V10H14M14,16H10V14H14M20,8H17.19C16.74,7.22 16.12,6.55 15.37,6.04L17,4.41L15.59,3L13.42,5.17C12.96,5.06 12.5,5 12,5C11.5,5 11.04,5.06 10.59,5.17L8.41,3L7,4.41L8.62,6.04C7.88,6.55 7.26,7.22 6.81,8H4A2,2 0 0,0 2,10V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V10A2,2 0 0,0 20,8Z"/>
                            </svg>
                            Play Pass
                        </a>
                        <a href="#" className="drawer-item">
                            <svg className="drawer-item-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V9M19,19H5V19H19V19Z"/>
                            </svg>
                            Play Points
                        </a> */}
                    </div>

                    <div className="drawer-divider"></div>

                    <div className="drawer-section">
                        <NavLink to="/settings" className={({ isActive }) => "drawer-item" + (isActive ? " active" : "")}>
                            <svg className="drawer-item-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.98C19.47,12.66 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11.02L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.65 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11.02C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.98Z" />
                            </svg>
                            {t('Settings')}
                        </NavLink>
                        <NavLink to="/help" className={({ isActive }) => "drawer-item" + (isActive ? " active" : "")}>
                            <svg className="drawer-item-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M11,18H13V16H11V18M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3Z" />
                            </svg>
                            {t('Help & feedback')}
                        </NavLink>
                        <NavLink to="/parental-guide" className="drawer-item">
                            <svg className="drawer-item-icon" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M12,3.18L19,6.3V11.22C19,15.54 16.03,19.45 12,20.81C7.97,19.45 5,15.54 5,11.22V6.3L12,3.18M15.09,8.59L14,7.5L12,9.5L10,7.5L8.91,8.59L10.91,10.59L8.91,12.59L10,13.68L12,11.68L14,13.68L15.09,12.59L13.09,10.59L15.09,8.59Z" />
                            </svg>
                            {t('Parent Guide')}
                        </NavLink>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Drawer;